<template>
  <div>
    <el-form label-position="top" class="u-mb-10" v-if="exibeSelectInstituicao">
      <el-row :gutter="10">
        <el-col :xs="24" :sm="24" :md="24">
          <el-form-item label="Instituição">
            <el-select v-model="filtroInstituicao.id" filterable disabled placeholder="Instituição" style="width:100%">
              <el-option v-for="(item, i) in $store.state.instituicoes" :key="i" :label="item.nome" :value="item.id"></el-option>
            </el-select>
            <small class="u-text-muted">Para trocar de instituição, volte para a listagem.</small>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <div v-if="edit && !dados.id" class="loading-form" style="min-height: 130px;">
      <img src="/public/img/loading-bar.gif" />
    </div>

    <el-form @submit.native.prevent="onSubmit" v-if="!edit || dados.id" :model="dados" ref="dados" label-position="top">
      <div v-if="!edit || dados.id">
        <el-row :gutter="10">
          <el-col :xs="24" :sm="20" :md="20">
            <el-form-item label="Fornecedor" prop="fornecedor_id" key="fornecedor_id">
              <el-select v-model="dados.fornecedor_id" placeholder="pesquisar" filterable remote clearable :remote-method="searchFornecedor" :loading="loadingFornecedor">
                <el-option v-for="item in fornecedores" :key="item.id" :label="item.nome" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="4" :md="4">
            <el-form-item label="">
              <el-button type="primary" plain icon="el-icon-plus" @click="abrirNovoFornecedor" style="width: 100%; margin-top: 20px;">NOVO</el-button>
            </el-form-item>
          </el-col>
        </el-row>

        <el-dialog title="Cadastrar Fornecedor" :visible.sync="dialogFornecedor.visible" width="560px" append-to-body>
          <el-form :model="dialogFornecedor.dados" ref="dialogFornecedorForm" label-position="top">
            <el-row :gutter="10">
              <el-col :xs="24" :sm="8" :md="8">
                <el-form-item label="Tipo" prop="tipo_fornecedor" :rules="[$requiredChange]" key="tipo_fornecedor_dlg">
                  <el-select v-model="dialogFornecedor.dados.tipo_fornecedor">
                    <el-option label="EMPRESA" value="empresa"></el-option>
                    <el-option label="AGRICULTURA FAMILIAR" value="agricultura_familiar"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="16" :md="16">
                <el-form-item label="Nome" prop="nome" :rules="[$requiredBlur]" key="nome_dlg">
                  <el-input v-model="dialogFornecedor.dados.nome" maxlength="191"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24" :sm="12" :md="12">
                <el-form-item label="CNPJ" prop="cnpj" key="cnpj_dlg">
                  <el-input v-model="dialogFornecedor.dados.cnpj" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
              <el-col :xs="24" :sm="12" :md="12">
                <el-form-item label="Telefone" prop="telefone" key="tel_dlg">
                  <el-input v-model="dialogFornecedor.dados.telefone" maxlength="20"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="10">
              <el-col :xs="24">
                <el-form-item label="E-mail" prop="email" key="email_dlg">
                  <el-input v-model="dialogFornecedor.dados.email" maxlength="191"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
          <span slot="footer">
            <el-button @click="dialogFornecedor.visible = false">CANCELAR</el-button>
            <el-button class="u-ml-10" type="primary" @click="salvarNovoFornecedor" :loading="dialogFornecedor.loading">SALVAR</el-button>
          </span>
        </el-dialog>

        <el-row :gutter="10">
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Data de entrada" prop="data_entrada" :rules="[$requiredChange]" key="data_entrada">
              <el-date-picker v-model="dados.data_entrada" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Número da nota" prop="numero_nota" key="numero_nota">
              <el-input v-model="dados.numero_nota" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="8" :md="8">
            <el-form-item label="Documento" prop="documento" key="documento">
              <el-input v-model="dados.documento" maxlength="191"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <c-panel title="Itens da entrada" titleIcon="fas fa-boxes">
          <el-row :gutter="10" class="u-mb-10">
            <el-col :xs="24" :sm="24" :md="24" class="u-text-right">
              <el-button type="primary" plain icon="el-icon-plus" @click="addItem">ADICIONAR ITEM</el-button>
            </el-col>
          </el-row>

          <div class="container-table">
            <table class="table table-striped">
              <thead>
                <tr>
                  <th>Alimento</th>
                  <th style="width: 120px;">Qtd</th>
                  <th style="width: 140px;">Vlr unit</th>
                  <th style="width: 140px;">Validade</th>
                  <th style="width: 120px;" class="u-text-center">Ação</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, idx) in itens" :key="idx">
                  <td>
                    <el-select v-model="item.alimento_id" placeholder="pesquisar" filterable remote clearable :remote-method="(q) => searchAlimento(q, idx)" :loading="item.loadingAlimento">
                      <el-option v-for="a in item.alimentos" :key="a.id" :label="a.nome" :value="a.id"></el-option>
                    </el-select>
                  </td>
                  <td>
                    <el-input v-model="item.quantidade" maxlength="20"></el-input>
                  </td>
                  <td>
                    <el-input v-model="item.valor_unitario" maxlength="20"></el-input>
                  </td>
                  <td>
                    <el-date-picker v-model="item.validade" type="date" format="dd/MM/yyyy" value-format="yyyy-MM-dd" placeholder="Selecione"></el-date-picker>
                  </td>
                  <td class="u-text-center">
                    <el-button v-if="edit && item.id" @click="saveItem(item)" type="info" icon="el-icon-check" size="mini" plain title="Salvar item"></el-button>
                    <el-button class="u-ml-10" @click="removeItem(item, idx)" type="danger" icon="el-icon-delete" size="mini" plain title="Remover item"></el-button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </c-panel>

        <el-row :gutter="10">
          <el-col :xs="24">
            <el-form-item class="u-text-right u-mt-15">
              <el-button type="primary" id="btn-entrada" native-type="submit">SALVAR</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  props: ['paramId'],
  components: {
    cPanel: () => import('@/shared/c-panel/c-panel.vue')
  },
  data: () => ({
    edit: false,
    loadingFornecedor: false,
    fornecedores: [],
    filtroInstituicao: { id: '', nome: '' },
    dialogFornecedor: {
      visible: false,
      loading: false,
      dados: { nome: '', cnpj: '', telefone: '', email: '', tipo_fornecedor: 'empresa', ativo: true }
    },
    dados: {
      id: '',
      instituicao_id: '',
      fornecedor_id: '',
      data_entrada: '',
      numero_nota: '',
      documento: ''
    },
    itens: []
  }),
  computed: {
    exibeSelectInstituicao () {
      const t = Number(this.$store.state.user.tipo)
      return (t > 3 && t <= 8) || t === 10
    }
  },
  mounted () {
    this.restaurarInstituicaoDoQuery()
    if (this.$store.state.config.instituicao) {
      this.filtroInstituicao = { id: this.$store.state.config.instituicao.id, nome: this.$store.state.config.instituicao.nome }
    }
  },
  methods: {
    restaurarInstituicaoDoQuery () {
      const qId = this.$route.query.instituicao_id
      if (!qId) return
      const atual = this.$store.state.config.instituicao
      if (atual && atual.id && String(atual.id) === String(qId)) return
      const lista = this.$store.state.instituicoes || []
      const fromList = Array.isArray(lista)
        ? lista.find(x => x && String(x.id) === String(qId))
        : (lista[qId] || null)
      const inst = fromList || { id: qId, nome: '' }
      this.$store.commit('setInstituicao', inst)
    },
    async getById (id) {
      const res = await this.$axios.get(`${this.$store.state.config.baseUrlApi}/api/merenda/entrada/getById/` + id, this.$store.getters.getHeaderAuth)
      this.dados = JSON.parse(JSON.stringify(res.data.entrada))

      // Pré-popular options para o el-select remote (senão ele mostra o ID)
      if (res.data.entrada && res.data.entrada.fornecedor) {
        const f = res.data.entrada.fornecedor
        this.fornecedores = [{ id: f.id, nome: f.nome }]
      }

      this.itens = (res.data.itens || []).map(i => {
        const row = Object.assign({}, i, { alimentos: [], loadingAlimento: false })
        if (i.alimento) {
          row.alimentos = [{ id: i.alimento.id, nome: i.alimento.nome }]
        }
        return row
      })
    },
    searchFornecedor (query) {
      if (!query || query.length < 2) { this.fornecedores = []; return }
      this.loadingFornecedor = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/fornecedor/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.fornecedores = JSON.parse(JSON.stringify(res.data)); this.loadingFornecedor = false })
        .catch(e => { this.loadingFornecedor = false; this.$store.commit('throwException', e) })
    },
    abrirNovoFornecedor () {
      this.dialogFornecedor.dados = { nome: '', cnpj: '', telefone: '', email: '', tipo_fornecedor: 'empresa', ativo: true }
      this.dialogFornecedor.visible = true
    },
    salvarNovoFornecedor () {
      this.$refs.dialogFornecedorForm.validate(valid => {
        if (!valid) return
        this.dialogFornecedor.loading = true
        this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/financeiro/fornecedor/store`, this.dialogFornecedor.dados, this.$store.getters.getHeaderAuth)
          .then(response => {
            this.dialogFornecedor.loading = false
            if (response.data && response.data.erro) {
              const msg = typeof response.data.erro === 'string' ? response.data.erro : (response.data.erro.text || 'Erro ao salvar fornecedor.')
              return window.eventBus.$emit('alert', { msg, type: 'warning' })
            }
            const novo = response.data
            this.fornecedores = [{ id: novo.id, nome: novo.nome }]
            this.dados.fornecedor_id = novo.id
            this.dialogFornecedor.visible = false
            window.eventBus.$emit('alert', { msg: 'Fornecedor cadastrado.', type: 'success' })
          })
          .catch(e => { this.dialogFornecedor.loading = false; this.$store.commit('throwException', e) })
      })
    },
    searchAlimento (query, idx) {
      if (!query || query.length < 2) { this.itens[idx].alimentos = []; return }
      this.itens[idx].loadingAlimento = true
      this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/alimento/searchByNome`, { query }, this.$store.getters.getHeaderAuth)
        .then(res => { this.itens[idx].alimentos = JSON.parse(JSON.stringify(res.data)); this.itens[idx].loadingAlimento = false })
        .catch(e => { this.itens[idx].loadingAlimento = false; this.$store.commit('throwException', e) })
    },
    addItem () {
      this.itens.push({ id: '', alimento_id: '', quantidade: '', valor_unitario: '', validade: '', alimentos: [], loadingAlimento: false })
    },
    async removeItem (item, idx) {
      if (this.edit && item.id) {
        await this.$axios.delete(`${this.$store.state.config.baseUrlApi}/api/merenda/entrada-item/delete/` + item.id, this.$store.getters.getHeaderAuth)
      }
      this.itens.splice(idx, 1)
    },
    async saveItem (item) {
      if (!this.dados.id) return
      const payload = Object.assign({}, item, { entrada_id: this.dados.id })
      if (item.id) {
        await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/entrada-item/update/` + item.id, payload, this.$store.getters.getHeaderAuth)
      } else {
        const res = await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/entrada-item/store`, payload, this.$store.getters.getHeaderAuth)
        item.id = res.data.id
      }
      window.eventBus.$emit('alert', { msg: 'Item salvo.', type: 'success' })
    },
    onSubmit () {
      document.getElementById("btn-entrada").focus()
      this.$refs.dados.validate(async (valid) => {
        if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
        const inst = this.$store.state.config.instituicao
        if (!inst || !inst.id) {
          return window.eventBus.$emit('alert', { msg: 'Selecione uma instituição antes de salvar.', type: 'warning' })
        }
        window.eventBus.$emit('loading', true)
        try {
          this.dados.instituicao_id = inst.id
          if (this.edit) {
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/entrada/update/` + this.dados.id, this.dados, this.$store.getters.getHeaderAuth)
            // itens: salvar via endpoints
            for (const it of this.itens) {
              if (it.id) continue
              if (!it.alimento_id || !it.quantidade) continue
              await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/entrada-item/store`, Object.assign({}, it, { entrada_id: this.dados.id }), this.$store.getters.getHeaderAuth)
            }
          } else {
            const payload = Object.assign({}, this.dados, { itens: this.itens.map(i => ({ alimento_id: i.alimento_id, quantidade: i.quantidade, valor_unitario: i.valor_unitario, validade: i.validade })) })
            await this.$axios.post(`${this.$store.state.config.baseUrlApi}/api/merenda/entrada/store`, payload, this.$store.getters.getHeaderAuth)
          }
          window.eventBus.$emit('loading', false)
          window.eventBus.$emit('alert', { msg: 'Sucesso! - Operação realizada com Sucesso!', type: 'success' })
          this.$emit('onSubmitEntrada')
        } catch (e) {
          window.eventBus.$emit('loading', false)
          this.$store.commit('throwException', e)
        }
      })
    }
  },
  watch: {
    paramId: {
      immediate: true,
      async handler (value) {
        if (value) {
          this.edit = true
          await this.getById(value)
        } else if (!this.itens.length) {
          this.addItem()
        }
      }
    }
  }
}
</script>

